<template>
   <div class="page-sign-todo">
      <div class="pg-breadcrumb">
         <div class="breadcrumb-item em">報表統計</div>
         <div class="breadcrumb-item">支付明細</div>
      </div>

      <div class="card-block">
         <Form inline class="pg-form-inline">
            <FormItem>
               <Select size="small" placeholder="提貨櫃點" v-model="form.store_id" clearable>
                  <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                          :key="item.ReceivingID">({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
               </Select>
            </FormItem>
            <FormItem>
               <Select size="small" placeholder="支付途徑" v-model="form.paytype" ref="resetSelect" clearable>
                  <Option :value="1">APP端積分充值</Option>
                  <Option :value="2">PC端積分充值</Option>
                  <Option :value="3">App端簽收費用支付</Option>
                  <Option :value="4">PC端簽收</Option>
                  <Option :value="5">送貨上門簽收</Option>
                  <Option :value="6">智能櫃費用簽收</Option>
                  <Option :value="7">其他簽收</Option>
               </Select>
            </FormItem>
            <FormItem>
               <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                           placeholder="流水號創建-開始日期" value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;"
                           :editable="false" v-model="form.start_time"></DatePicker>
            </FormItem>
            <FormItem>-</FormItem>
            <FormItem>
               <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                           placeholder="流水號創建-結束日期" value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;"
                           :editable="false" v-model="form.end_time"></DatePicker>
            </FormItem>
         </Form>

         <Form inline class="pg-form-inline form-input-wrap">
            <FormItem>
               <label class="input-label">流水號碼</label>
               <Input size="small" clearable v-model="form.serial_number" @keyup.enter.native="handleSearch()"
                      clearable></Input>
            </FormItem>
            <FormItem>
               <label class="input-label">客戶名稱</label>
               <Input size="small" clearable v-model="form.uid" @keyup.enter.native="handleSearch()" clearable></Input>
            </FormItem>
            <FormItem>
               <label class="input-label">客戶電話</label>
               <Input size="small" clearable v-model="form.phone" @keyup.enter.native="handleSearch()"
                      clearable></Input>
            </FormItem>
            <FormItem>
               <div class="pg-btn-wrap">
                  <div class="pg-btn style1" @click="handleSearch">搜索</div>
                  <div class="pg-btn style2" @click="handleExport">導出excel</div>
               </div>
            </FormItem>
         </Form>
      </div>

      <div class="card-block pd-bt">
         <Spin fix class="pg-sub-loading" v-if="isSubmiting">
            <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
            <div class="loading-text">Loading</div>
         </Spin>

         <Table ref="table"
                size="small"
                border
                no-data-text="暫無數據"
                :columns="table.column"
                :data="table.data">
            <template slot-scope="{ row, index }" slot="action">
               <div class="pg-btn-wrap">
                  <div class="pg-btn style2" @click="handleModalSignShow(index)">詳情</div>
               </div>
            </template>
         </Table>

         <div class="pg-pagger">
            <Row>
               <Col span="12" class="pagger-left">
                  <div class="pagger-total">總共 {{ totalCount }} 條記錄</div>
               </Col>
               <Col span="12" class="pagger-right">
                  <!-- v-if="totalCount > curPageSize" -->
                  <div>
                     <div class="pagger-sizer">
                        <span>每頁</span>
                        <Select v-model="curPageSize" size="small" placeholder="數量"
                                @on-change="handlePageSizeChange">
                           <Option :value="10">10</Option>
                           <Option :value="20">20</Option>
                           <Option :value="30">30</Option>
                           <Option :value="40">40</Option>
                           <Option :value="50">50</Option>
                        </Select>
                     </div>

                     <div class="pagger-elevator">
                        <span>跳轉</span>
                        <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                               @on-enter="handlePageEnter"/>
                     </div>

                     <Page size="small"
                           :current="pageIndex"
                           :page-size="curPageSize"
                           :total="totalCount"
                           @on-change="handlePageChange">
                     </Page>
                  </div>
               </Col>
            </Row>
         </div>
      </div>

      <Modal v-model="isShowModalSign"
             title="訂單詳情"
             width="650"
             :footer-hide="true"
             @on-cancel="handleModalSignClose">
         <div class="modal-cont">
            <div class="modal-sous">流水號: {{ serial_number_single }}</div>
            <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
               <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
               <div class="loading-text">Loading</div>
            </Spin>
            <Table ref="table"
                   size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table_log.column_log"
                   :data="table_log.data_log">
            </Table>
         </div>
      </Modal>

   </div>
</template>

<script>
import Store from '../../../assets/js/store.js'

let isthis;
export default {
   data() {
      return {
         pageIndex: 1,
         curPageSize: 10,
         totalCount: 1,
         pageInput: '',
         pickAddress: [],
         pickShelves: [],
         isSubmiting: false,
         isSubmitingLog: false,
         isShowModalSign: false,
         serial_number_single: '',

         form: {
            uid: '',
            paytype: '',
            store_id: Store.fetch().store_id,
            // phone:'',
            serial_number: '',
            created_at: ''
         },
         table: {
            column: [
               {
                  title: '操作',
                  slot: 'action',
                  align: 'center',
                  minWidth: 100
               },
               {
                  title: '創單時間',
                  key: 'created_at',
                  align: 'center',
                  minWidth: 150,
                  sortable: true
               },
               {
                  title: '客戶名稱',
                  key: 'orderu_user',
                  align: 'center',
                  minWidth: 130,
                  sortable: true
               },
               {
                  title: '客戶號碼',
                  key: 'phone',
                  align: 'center',
                  minWidth: 130,
                  sortable: true
               },
               {
                  title: '流水號碼',
                  key: 'serial_number',
                  align: 'center',
                  minWidth: 300,
                  sortable: true
               },
               {
                  title: '訂單類型',
                  key: 'paytype',
                  align: 'center',
                  minWidth: 150,
                  sortable: true
               },
               {
                  title: '支付費用',
                  key: 'lump_sum',
                  align: 'center',
                  minWidth: 60,
                  sortable: true
               },
               {
                  title: '立減費用',
                  key: 'instant_reduction',
                  align: 'center',
                  minWidth: 60,
                  sortable: true
               },
               {
                  title: '支付方式',
                  key: 'order_type',
                  align: 'center',
                  minWidth: 130,
                  sortable: true
               },
               {
                  title: '支付途徑',
                  key: 'order_online',
                  align: 'center',
                  minWidth: 130,
                  sortable: true
               },
               {
                  title: '支付時間',
                  key: 'created_at',
                  align: 'center',
                  minWidth: 150,
                  sortable: true
               },
            ],
            data: []
         },
         table_log: {
            column_log: [
               {
                  title: '快遞單號',
                  align: 'center',
                  key: 'id_log',
                  minWidth: 100
               },
               {
                  title: '總金額',
                  align: 'center',
                  key: 'lump_sum',
                  minWidth: 50
               },
            ],
            data_log: []
         },
      };
   },
   created() {
      this.getPickAddress();
   },
   mounted() {
      this.getList();
   },
   methods: {
      formatDate(datetime) {
         if (!datetime) return '';
         let dateTime = new Date(datetime);
         let year = dateTime.getFullYear();
         let month = dateTime.getMonth() + 1;
         let date = dateTime.getDate();
         let hour = dateTime.getHours();
         let minute = dateTime.getMinutes();
         let second = dateTime.getSeconds();
         let milliseconds = dateTime.getMilliseconds();
         return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
      },
      formatNum(num) {
         return num < 10 ? '0' + num : num;
      },
      getPickAddress() //提貨櫃點
      {
         this.$Rq.requestAuth({
            url: this.$Api.pickAddress,
            method: 'get',
            data: {
               company_id: 1,
            }
         }).then((res) => {
            if (res.code == 0) {
               this.pickAddress = res.data.data;
               if (res.data.data.length <= 1) {
                  this.form.arrive = res.data.data[0].ReceivingID;
               }
            }
         });
      },
      handleStoreChange(index) {
         this.$refs.resetSelect.clearSingleSelect();
      },
      getList() {
         let form = this.form;
         this.isSubmiting = true;
         this.$Rq.requestAuth({
            url: this.$Api.payInfoList,
            method: 'get',
            data: {
               uid: form.uid,
               paytype: form.paytype,
               store_id: form.store_id,
               serial_number: form.serial_number,
               // phone: form.phone,
               start_time: this.formatDate(form.start_time),
               end_time: this.formatDate(form.end_time),
               offset: (this.pageIndex - 1) * this.curPageSize,
               limit: this.curPageSize
            }
         }).then((res) => {
            this.isSubmiting = false;
            if (res.code == 0) {
               let tempArr = [];
               let paytype_string;
               let resData = res.data.data;

               for (let i = 0; i < resData.length; i++) {
                  if (resData[i].orderu_user == null) {
                     resData[i].orderu_user = "";
                  }

                  if (resData[i].paytype == 1) {
                     paytype_string = "APP端積分充值";
                  }
                  if (resData[i].paytype == 2) {
                     paytype_string = "PC端積分充值";
                  }
                  if (resData[i].paytype == 3) {
                     paytype_string = "APP端簽收費用支付";
                  }
                  if (resData[i].paytype == 4) {
                     paytype_string = "PC端簽收";
                  }
                  if (resData[i].paytype == 5) {
                     paytype_string = "送貨上門簽收";
                  }
                  if (resData[i].paytype == 6) {
                     paytype_string = "智能櫃費用簽收";
                  }
                  if (resData[i].paytype == 7) {
                     paytype_string = "其他簽收";
                  }

                  tempArr.push({
                     created_at: resData[i].created_at,
                     orderu_user: resData[i].orderu_user.user_name ? resData[i].orderu_user.user_name : '- - -',
                     phone: resData[i].orderu_user.phone ? resData[i].orderu_user.phone : '- - -',
                     serial_number: resData[i].serial_number,
                     lump_sum: resData[i].lump_sum,
                     paytype: paytype_string,
                     instant_reduction: resData[i].instant_reduction != null ? resData[i].instant_reduction : '- - -',
                     order_type: resData[i].order_type != null ? resData[i].order_type : '- - -',
                     order_online: resData[i].order_online != null ? resData[i].order_online : '- - -',
                  });

               }
               this.totalCount = res.data.count;
               this.table.data = tempArr;
            } else {
               this.showTipInfo(res.msg);
            }
         }).catch((err) => {
            this.isSubmiting = false;
         });
      },

      handleModalSignShow(index) {
         this.isShowModalSign = true;
         this.isSubmitingLog = true;
         let tableData = this.table.data;
         let floworder = tableData[index].serial_number;
         this.serial_number_single = tableData[index].serial_number;
         this.$Rq.requestAuth({
            url: this.$Api.payInfoList_Orderflow,
            method: 'post',
            data: {
               floworder
            }
         }).then((res) => {
            this.isSubmitingLog = false;
            if (res.code == 0) {
               let tempArr_log = [];
               let resData = res.data;

               for (let i = 0; i < resData.length; i++) {

                  if (resData[i].order_goods != '') {
                     for (let j = 0; j < resData[i].order_goods.length; j++) {

                        let alipay = resData[i].order_goods[j].orderamount.alipay != '' ? resData[i].order_goods[j].orderamount.alipay : 0;

                        let bocwechat = resData[i].order_goods[j].orderamount.bocwechat != '' ? resData[i].order_goods[j].orderamount.bocwechat : 0;

                        let cash = resData[i].order_goods[j].orderamount.cash != '' ? resData[i].order_goods[j].orderamount.cash : 0;

                        let credit = resData[i].order_goods[j].orderamount.credit != '' ? resData[i].order_goods[j].orderamount.credit : 0;

                        let credit_tw = resData[i].order_goods[j].orderamount.credit_tw != '' ? resData[i].order_goods[j].orderamount.credit_tw : 0;

                        let icbc = resData[i].order_goods[j].orderamount.icbc != '' ? resData[i].order_goods[j].orderamount.icbc : 0;

                        let icbcwechat = resData[i].order_goods[j].orderamount.icbcwechat != '' ? resData[i].order_goods[j].orderamount.icbcwechat : 0;

                        let macaupay = resData[i].order_goods[j].orderamount.macaupay != '' ? resData[i].order_goods[j].orderamount.macaupay : 0;

                        let mpay = resData[i].order_goods[j].orderamount.mpay != '' ? resData[i].order_goods[j].orderamount.mpay : 0;

                        let wechat = resData[i].order_goods[j].orderamount.wechat != '' ? resData[i].order_goods[j].orderamount.wechat : 0;

                        tempArr_log.push({
                           id_log: resData[i].order_goods[j] != null ? resData[i].order_goods[j].odd_numbers : '- - -',
                           lump_sum: Number(alipay + bocwechat + cash + credit + credit_tw + icbc + icbcwechat + macaupay + mpay + wechat)
                        });
                     }
                  } else {
                     tempArr_log.push({
                        id_log: resData[i].serial_number,
                        lump_sum: resData[i].lump_sum
                     });
                  }
               }

               this.table_log.data_log = tempArr_log;
            }

         }).catch((err) => {
            this.isSubmitingLog = false;
         });
      },

      handleModalSignClose() {
         this.isShowModalSign = false;
      },

      handleSearch() {
         this.pageIndex = 1;
         this.getList();
      },

      handleExport() {
         let token = localStorage.getItem('jyb_token');
         let form = this.form;
         let params = {
            // arrive: form.arrive,
            paytype: form.paytype,
            start_time: this.formatDate(form.start_time),
            end_time: this.formatDate(form.end_time),
            // serial_number: form.serial_number,
            // phone: form.phone,
            // uid: form.uid
         };
         let formatParams = this.$Utils.formateObjToParamStr(params);
         // if(form.start_time == ''){
         // 	this.$Utils.showTipInfo("請選擇起始時間");
         // }
         // else if(form.end_time == ''){
         // 	this.$Utils.showTipInfo("請選擇结束時間");
         // }
         // else{
         window.open(`${this.$Api.payOrderflow_export}?${formatParams}`, '_blank');
         // this.exportLink = `${this.$Api.deliverFexport}?${formatParams}`;
         // }
      },

      handlePageSizeChange(value) {
         this.pageIndex = 1;
         this.getList();
      },

      handlePageInput() {
         let value = ('' + this.pageInput).replace(/\D/g, '');
         let pageCount = Math.floor(this.totalCount / this.curPageSize);
         if (value > pageCount) {
            value = pageCount;
         }
         this.pageInput = value;
      },

      handlePageEnter() {
         if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
         if (this.pageInput == 0) {
            this.pageInput = 1;
         }
         this.pageInput = parseInt(this.pageInput);
         this.pageIndex = this.pageInput;
         this.getList();
      },

      handlePageChange(value) {
         this.pageIndex = value;
         this.getList();
      }
   }
};
</script>

<style lang="scss" scoped>
@import 'payInfo.scss';
</style>
